import { inject, Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { NavController, Platform } from "@ionic/angular";

@Injectable()
export class NavigationService {
  platform = inject(Platform);
  nav = inject(NavController);
  activatedRoute = inject(ActivatedRoute);

  backButtonHandler?: () => void;

  // Name and function for invoking page-specific back
  pageBackFile?: string;
  pageBack?: () => boolean;

  isKeyboardOnscreen = false;

  constructor() {
    // Subscribes once to the Ionic back button event
    // Does not call the next one in the stack, as there is no way
    // to tell if the next handler will do the native function
    // and pop a page off the stack.
    // 101, as closing ion-modal gets a priority of 100
    this.platform.backButton.subscribeWithPriority(101, () => {
      if (this.backButtonHandler) {
        this.backButtonHandler();
      }
    });

    // todo: Use the Ionic keyboard plugin instead, which supports PWAs
    if (Capacitor.getPlatform() !== "web") {
      void Keyboard.addListener("keyboardWillShow", (_info) => {
        this.isKeyboardOnscreen = true;
      });

      void Keyboard.addListener("keyboardDidShow", (_info) => {
        this.isKeyboardOnscreen = true;
      });

      void Keyboard.addListener("keyboardWillHide", () => {
        this.isKeyboardOnscreen = false;
      });

      void Keyboard.addListener("keyboardDidHide", () => {
        this.isKeyboardOnscreen = false;
      });
    }
  }

  async to(url: string, force = false) {
    if (window.location.pathname === url) {
      if (force) {
        window.location.href = url;
        return;
      } else {
        return;
      }
    } else {
      return await this.nav.navigateForward(url);
    }
  }

  // Navigate, destroying Angular state
  public static forceTo(url: string) {
    if (window.location.pathname === url) {
      window.location.reload();
    } else {
      window.location.href = url;
    }
  }

  public async back() {
    // Try the Angular router stack
    if (await this.nav.pop()) {
      return;
    }

    // Fallback to browser
    history.go(-1);
  }

  public static reload() {
    window.location.reload();
  }
}
